import { IConstructorOptions } from "../../../Utilities";
import { BasicEntityWatcher } from "../EntityWatcher";
import { DataEntityBase } from "./Base/DataEntityBase";
import { Models } from "./Base/Models";

export enum UserProfileProperties {
    firstName = '_firstName',
    lastName = '_lastName',
    email = '_email',
    recapList = '_recapList',

    appVersion = '_appVersion',
    appVersionDate = '_appVersionDate',
    lastFeedbackDate = '_lastFeedbackDate',

    appRing = '_appRing',
    isTestAccount = '_isTestAccount',
}

export type AppRing = "Production" | "PublicPreview" | "Selfhost";

export class UserProfile extends DataEntityBase {

    public static get TypeName() { return Models.UserProfile; }
    public static CreateId(_key: string) {
        return DataEntityBase.CreateId(UserProfile.TypeName, _key)
    };

    public static Create(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        var retVal = new UserProfile(options);
        watcher.RegisterEntity(retVal);
        return retVal;
    }

    //
    // Header
    //
    public get userId(): string | undefined { return this.key; }
    public set userId(value: string) { this.key = value; }

    public get firstName(): string { return this[UserProfileProperties.firstName]; }
    public set firstName(value: string) { this.UpdateAndFire(UserProfileProperties.firstName, value); }
    [UserProfileProperties.firstName] = "";

    public get lastName(): string { return this[UserProfileProperties.lastName]; }
    public set lastName(value: string) { this.UpdateAndFire(UserProfileProperties.lastName, value); }
    [UserProfileProperties.lastName] = "";

    public get email(): string { return this[UserProfileProperties.email]; }
    public set email(value: string) { this.UpdateAndFire(UserProfileProperties.email, value); }
    [UserProfileProperties.email] = "";

    public get recapList(): string[] { return this[UserProfileProperties.recapList]; }
    public set recapList(value: string[]) { this.UpdateAndFire(UserProfileProperties.recapList, value); }
    [UserProfileProperties.recapList] = [];

    public get appVersion(): string { return this[UserProfileProperties.appVersion]; }
    public set appVersion(value: string) { this.UpdateAndFire(UserProfileProperties.appVersion, value); }
    [UserProfileProperties.appVersion] = "";

    public get appVersionDate(): Date | undefined { return this[UserProfileProperties.appVersionDate]; }
    public set appVersionDate(value: Date | undefined) { this.UpdateAndFire(UserProfileProperties.appVersionDate, value); }
    [UserProfileProperties.appVersionDate] = undefined;

    public get lastFeedbackDate(): Date | undefined { return this[UserProfileProperties.lastFeedbackDate]; }
    public set lastFeedbackDate(value: Date | undefined) { this.UpdateAndFire(UserProfileProperties.lastFeedbackDate, value); }
    [UserProfileProperties.lastFeedbackDate] = undefined;

    public get appRing(): AppRing { return this[UserProfileProperties.appRing] as AppRing; }
    public set appRing(value: AppRing) { this.UpdateAndFire(UserProfileProperties.appRing, value); }
    [UserProfileProperties.appRing] = "Production";

    public get isTestAccount(): boolean { return this[UserProfileProperties.isTestAccount]; }
    public set isTestAccount(value: boolean) { this.UpdateAndFire(UserProfileProperties.isTestAccount, value); }
    [UserProfileProperties.isTestAccount] = false;


    private constructor(options?: IConstructorOptions) {

        super(
            {
                typename: UserProfile.TypeName,
                serializationProperties: UserProfileProperties,
                dateProperties: UserProfile.dateProperties,
                jsonProperties: UserProfile.jsonProperties
            },);
        this.CompleteConstruction(options);
    }

    private static dateProperties: string[] = [
        UserProfileProperties.appVersionDate,
        UserProfileProperties.lastFeedbackDate
    ];


    private static jsonProperties: string[] = [
        UserProfileProperties.recapList
    ];
}